import type { JobStatus } from "@/hooks/use-jobs";
import { cn } from "@/lib/utils";

const STYLES: Record<JobStatus, string> = {
  pending: "bg-neutral-100 text-neutral-700 dark:bg-neutral-900 dark:text-neutral-300",
  holding: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
  running: "bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-300",
  completed: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  failed: "bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-300",
  refunded: "bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-300",
  cancelled: "bg-neutral-100 text-neutral-600 dark:bg-neutral-900 dark:text-neutral-400",
};

export function StatusBadge({ status }: { status: JobStatus }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize",
        STYLES[status] ?? STYLES.pending,
      )}
    >
      {status}
    </span>
  );
}
